import _Modules from '../core--modules';
import _bundle from '../core--bundles';

export default new _Modules({
    name: 'Page Update',
    settings: {
        block: ''
    },
    fn() {
        _bundle.add({
            name: 'Module: Test Page Update',
            event: ['on:PageUpdate'],
            weight: 550,
            fn() {
                $('#event-test-jquery').prepend($(`<li>Module Done!</li>`));
            }
        });
    }
});
